/* istanbul ignore file */
import ENV from "glesys-controlpanel/config/environment";

function isMirageCompiledIn() {
  return Boolean(import.meta.env.VITE_MIRAGE) && ENV.devtools;
}

function readMirageState() {
  try {
    return JSON.parse(localStorage.getItem("glesys:devtools") ?? "{}").mirage ?? {};
  } catch {
    return {};
  }
}

const scenarioLoaders = import.meta.glob("../mirage/scenarios/[!_]*.{js,ts}");

function findScenarioLoader(name) {
  return Object.entries(scenarioLoaders).find(
    ([path]) =>
      path
        .split("/")
        .pop()
        .replace(/\.\w+$/, "") === name,
  )?.[1];
}

export async function initialize(app) {
  if (!isMirageCompiledIn()) {
    return;
  }

  let state = readMirageState();

  if (!state.enabled) {
    globalThis.setWarpDriveIsMaybeMirage?.(false);
    return;
  }

  app.deferReadiness();

  try {
    const [{ createServer }, { default: users }] = await Promise.all([
      import("glesys-controlpanel/mirage/servers/default"),
      import("glesys-controlpanel/mirage/fixtures/users"),
    ]);

    let scenarioName = state.scenario ?? "default";
    let scenarioLoader = findScenarioLoader(scenarioName);

    if (!scenarioLoader) {
      // eslint-disable-next-line no-console
      console.warn(`[mirage] unknown scenario "${scenarioName}", using "default"`);
      scenarioName = "default";
      scenarioLoader = findScenarioLoader(scenarioName);
    }

    const { default: seed } = await scenarioLoader();

    const server = createServer({ environment: "development", logging: true });
    server.pretender.unhandledRequest = (verb, path) => {
      throw new Error(`[mirage] unhandled ${verb} ${path}`);
    };

    globalThis.setWarpDriveIsMaybeMirage?.(true);

    seed(server);

    /* eslint-disable no-console */
    console.info(`%c[mirage] started — scenario: ${scenarioName}`, "color: #5A984B; font-weight: bold;");
    console.table(
      users.map((u) => ({
        username: u.username,
        password: u.password,
        otp: u.otp ?? "—",
        verification: u.verificationcode ?? "—",
        state: u.loginState ?? "ok",
      })),
    );
    /* eslint-enable no-console */
  } finally {
    app.advanceReadiness();
  }
}

export default {
  name: "mirage",
  initialize,
};
